'use strict';

const $ = window.jQuery;

export default class StickyPush {
    constructor() {
        if ( $('.sticky-push').length <= 0 ) {
            return
        }

        const $wrapper = $('.sticky-push')
        const $btn     = $('#displayStickyPush')
        const $push    = $('#stickyPush')
        const $pushH   = $push.get(0).scrollHeight

        $btn.height($pushH)

        $btn.on('click', function() {
            $wrapper.toggleClass('is-active')
            $(this).animate({
                height: $pushH
            }, 300 )
        })

        $('#closeStickyPush').on('click', function() {
            $wrapper.removeClass('is-active')
            setTimeout(function() {
                $btn.animate({
                    height: 60
                }, 300)
            }, 300)
        })
    }
}
